/**
 * Transpose a matrix (2D array) such that the rows become columns and the columns become rows. This function uses a
 * loop to avoid recursion and call stack overloading for large matrices. The input matrix is assumed to be rectangular
 * (i.e. all rows have the same number of columns). This does not mean all cells have values.
 *
 * @param matrix - The matrix to transpose
 */
export function transpose<T>(matrix: T[][]): T[][] {
  if (matrix.length === 0) return [];

  const rows = matrix.length;
  const cols = matrix[0].length;
  const transposed: T[][] = Array.from({ length: cols }, () => Array(rows));

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      transposed[j][i] = matrix[i][j];
    }
  }

  return transposed;
}
